import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect, useContext } from 'react';
import { Context } from './MapStateProvider';
import { DEFAULT_MAP_SETTINGS } from './constants';

/**
 * It is in charge of the map behavior when:
 * - The user searches for a place.
 * - The user share its location.
 * - The user selects a site.
 * - The user drags the map.
 * @param {string} place - Searched place.
 */
var MapHandler = function MapHandler(_ref) {
  var selectedPlace = _ref.selectedPlace,
    deviceLocation = _ref.deviceLocation,
    reStartMap = _ref.reStartMap;
  var map = useMap();
  var _useContext = useContext(Context),
    getFirstClusterFromNewCenter = _useContext.getFirstClusterFromNewCenter;

  /**
   * Calculate the bounds of the map based on the center and the closest cluster
   * @param {Object} center - Center of the map {lat, lng}
   */
  var calculateBounds = function calculateBounds(firstcluster) {
    var bounds = new window.google.maps.LatLngBounds();
    // Extending the bounds to include the sites of the closest cluster
    firstcluster === null || firstcluster === void 0 ? void 0 : firstcluster.forEach(function (_ref2) {
      var lat = _ref2.lat,
        lng = _ref2.lng;
      var clusterOnePosition = new google.maps.LatLng(lat, lng);
      bounds.extend(clusterOnePosition);
    });
    return bounds;
  };

  // Mapping viewport
  var extendViewportBundaries = function extendViewportBundaries(viewport) {
    var viewportHigh = new google.maps.LatLng(viewport.ei.hi, viewport.Gh.hi);
    var viewportLow = new google.maps.LatLng(viewport.ei.lo, viewport.Gh.lo);
    return {
      viewportHigh: viewportHigh,
      viewportLow: viewportLow
    };
  };

  /**
   * Re-center map to include the searched place and also at least more closer sites
   * @param {Object} map - Map inside the provider
   * @param {Object} place - place searched
   */
  var reCenterMap = function reCenterMap(map, place) {
    var _place$geometry;
    var firstcluster = getFirstClusterFromNewCenter(place.geometry.location.lat(), place.geometry.location.lng());
    var bounds = calculateBounds(firstcluster.slice(0, 3));
    var centerPosition = new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng());
    bounds.extend(centerPosition);
    if (place !== null && place !== void 0 && (_place$geometry = place.geometry) !== null && _place$geometry !== void 0 && _place$geometry.viewport) {
      var _extendViewportBundar = extendViewportBundaries(place.geometry.viewport),
        viewportHigh = _extendViewportBundar.viewportHigh,
        viewportLow = _extendViewportBundar.viewportLow;
      bounds.extend(viewportHigh);
      bounds.extend(viewportLow);
    }
    map.fitBounds(bounds);
  };
  useEffect(function () {
    var _selectedPlace$geomet, _selectedPlace$geomet2, _selectedPlace$geomet3, _selectedPlace$geomet4;
    if (!map || !selectedPlace) return;
    if (!(selectedPlace !== null && selectedPlace !== void 0 && (_selectedPlace$geomet = selectedPlace.geometry) !== null && _selectedPlace$geomet !== void 0 && (_selectedPlace$geomet2 = _selectedPlace$geomet.location) !== null && _selectedPlace$geomet2 !== void 0 && _selectedPlace$geomet2.lat())) return;
    if (!(selectedPlace !== null && selectedPlace !== void 0 && (_selectedPlace$geomet3 = selectedPlace.geometry) !== null && _selectedPlace$geomet3 !== void 0 && (_selectedPlace$geomet4 = _selectedPlace$geomet3.location) !== null && _selectedPlace$geomet4 !== void 0 && _selectedPlace$geomet4.lng())) return;
    reCenterMap(map, selectedPlace);
  }, [map, selectedPlace]);

  /**
   * Re-center map to include the location and also at least more closer sites
   * @param {Object} map - Map inside the provider
   * @param {Object} place - place searched
   */
  var reCenterMapByLocation = function reCenterMapByLocation(map, deviceLocation) {
    var firstcluster = getFirstClusterFromNewCenter(deviceLocation.lat, deviceLocation.lng);
    var bounds = calculateBounds(firstcluster);
    var centerPosition = new google.maps.LatLng(deviceLocation.lat, deviceLocation.lng);
    bounds.extend(centerPosition);
    map.fitBounds(bounds);
  };
  useEffect(function () {
    if (!map || !deviceLocation) return;
    if (!(deviceLocation !== null && deviceLocation !== void 0 && deviceLocation.lat)) return;
    if (!(deviceLocation !== null && deviceLocation !== void 0 && deviceLocation.lng)) return;
    reCenterMapByLocation(map, deviceLocation);
  }, [map, deviceLocation]);
  useEffect(function () {
    if (!map) return;
    map.setCenter(DEFAULT_MAP_SETTINGS.CENTER);
    map.setZoom(DEFAULT_MAP_SETTINGS.ZOOM);
    getFirstClusterFromNewCenter(DEFAULT_MAP_SETTINGS.CENTER.lat, DEFAULT_MAP_SETTINGS.CENTER.lng);
  }, [map, reStartMap]);
  return null;
};
export default /*#__PURE__*/React.memo(MapHandler);